export const FeatureFlags = {
    FooterTermsPrivacy: 'footer_terms_privacy'
  } as const;
  
  export type FeatureFlag = typeof FeatureFlags[keyof typeof FeatureFlags];